import Decimal from 'decimal.js'
import axios from 'axios'
export const defaultMenuType = 'menu-default' // 'menu-default', 'menu-sub-hidden', 'menu-hidden';
export const defaultStartPath = '/app/dashboards/default'
export const searchPath = '/app/pages/search'

var url_string = window.location.href
var url = new URL(url_string);
var url_token = url.searchParams.get("token") || null;
localStorage.setItem('token_job', url_token);
localStorage.setItem('py_app', (url_token) ? "APP" : "WEB");
//alert(url_token);

const axioscustom = axios.create()
axioscustom.defaults.headers.common['X-Mango-Auth'] = (url_token) ? url_token : localStorage.getItem('token_dc') || ''
axioscustom.defaults.headers.common['X-Customer-Auth'] = (url_token) ? url_token : localStorage.getItem('token_dc') || ''
axioscustom.defaults.headers.common['X-API-Auth'] = "Y" || ''
const axioscustom2 = axios.create()
axioscustom2.defaults.headers.common['X-Mango-Auth'] = (url_token) ? url_token : localStorage.getItem('token_dc') || ''
axioscustom2.defaults.headers.common['X-Customer-Auth'] = (url_token) ? url_token : localStorage.getItem('token_dc') || ''
axioscustom2.defaults.headers.common['X-API-Auth'] = "Y" || ''

export const subHiddenBreakpoint = 1440
export const menuHiddenBreakpoint = 768

export const defaultLocale = 'en'
export const localeOptions = [
  { id: 'en', name: 'English' },
  { id: 'es', name: 'Español' }
]

// export const firebaseConfig = {
//   apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
//   authDomain: 'gogo-react-login.firebaseapp.com',
//   databaseURL: 'https://gogo-react-login.firebaseio.com',
//   projectId: 'gogo-react-login',
//   storageBucket: 'gogo-react-login.appspot.com',
//   messagingSenderId: '216495999563'
// }

// http://172.16.10.243:8888/test2/
// export const apiUrl = "http://127.0.0.1:8888/test2/";//location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: '')+'/';
// export const apiUrl = "http://mangosystem.dyndns-remote.com/DC_Market/";

export const apiUrl = window.serverUrl

export const currentUser = {
  id: 1,
  title: 'xxx',
  img: '',
  date: 'xxx'
}

// const formpost = await function(url,formdata) {
//   axios.defaults.headers.common['X-Mango-Auth'] = localStorage.getItem("token") || '';
//   resp = await axios.post(apiUrl+url, formdata, { headers: { 'Content-Type': 'multipart/form-data' } });
//   return resp
// }
// export default formpost;
// const post = await function(url,formdata) {
//   axios.defaults.headers.common['X-Mango-Auth'] = localStorage.getItem("token") || '';
//   resp = await axios.post(apiUrl+url, formdata);
//   return resp
// }
// export default post;
// const get = await function(url) {
//   axios.defaults.headers.common['X-Mango-Auth'] = localStorage.getItem("token") || '';
//   resp = await axios.get(apiUrl+url);
//   return resp
// }

const $queryString = (a => {
  if (a == '') return {};
  let b = {};
  for (let i = 0; i < a.length; ++i) {
    let p = a[i].split('=', 2);
    b[p[0]] = (p.length == 1) ? '' : decodeURIComponent(p[1].replace(/\+/g, ' '));
  }
  return b;
})(window.location.search.substr(1).split('&'));

const $xtools = {
  qs: $queryString,
  isEmpty: function (x) {
    return x === undefined || x === null || x === ''
  },
  int(x) {
    return isNaN(parseInt(x)) ? 0 : parseInt(x)
  },
  dec(x, n) {
    if (isNaN(parseFloat(x))) return 0
    n = isNaN(parseInt(n)) ? 6 : parseInt(n)
    let dc = new Decimal(x).toDP(n).toNumber()
    return dc
  },
  async getLocal(url) {
    //let error = null
    let resp = await axioscustom.get(apiUrl + url)
    // console.log(resp)
    return resp.data
  },
  async postLocalJson(url, data) {
    //let error = null
    let resp = null
    resp = await axioscustom.post(apiUrl + url, data)
    // console.log(resp)
    return resp.data
  },
  async postLocalForm(url, formdata) {
    //let error = null
    let resp = null
    resp = await axioscustom.post(apiUrl + url, formdata, { headers: { 'Content-Type': 'multipart/form-data' } })
    // console.log(resp)
    return resp.data
  },
  async getServer(url) {
   // let error = null
    let resp = await axioscustom2.get(apiUrl + url).catch(function (error) {
      if (error.response) {
        if (error.response.status == 403) {
          window.location.href = baseUrl + 'page/authentication/login/'
        }
      }
    });
    // console.log(resp)
    return resp.data
  },
  async postServerJson(url, data) {
    //let error = null
    let resp = null
    resp = await axioscustom2.post(apiUrl + url, data)

    // console.log(resp)
    return resp.data
  },
  async postServerForm(url, formdata) {
    //let error = null
    let resp = null
    resp = await axioscustom2.post(apiUrl + url, formdata, { headers: { 'Content-Type': 'multipart/form-data' } })
    // console.log(resp)
    return resp.data
  },
  //Save Logs
  async onSaveActionLogs(module, task, docno) {
    let tmp = {
      module: module,
      tasks: task,
      docno: docno
    }
    let url = `Api/ErrorLog/CreateActionLog`;

    await this.postServerForm(url, tmp);
    // console.log("Logs has been save!!  (module: ", tmp.module, "tasks: ", tmp.tasks, "docno: ", tmp.docno + ")");
  },
  showResult(d, success_text, minimize) {
    if (d.success) {
      if (!$xtools.isEmpty(success_text)) {
        if (minimize) {
          $notify.success(success_text)
        } else {
          $alert('', success_text, 'success')
        }
      }
    } else {
      throw d.error
    }
  },
  showError(err, ui) {
    let msg = err.toString()
    if ($xt.strStartWith(msg, '[ui_code]')) {
      msg = ui[msg.split(':')[1]] || msg
    }

    $alert('', msg, 'danger')
  },
  strStartWith(str, strCompare) {
    str = str || ''
    str = str.toLowerCase()

    strCompare = strCompare || ''
    strCompare = strCompare.toLowerCase()

    return str.indexOf(strCompare) === 0
  },
  strContains(str, strCompare) {
    str = str || ''
    str = str.toLowerCase()

    strCompare = strCompare || ''
    strCompare = strCompare.toLowerCase()

    return str.indexOf(strCompare) > -1
  },
  checkEmpty(obj, props) {
    return $linq(props).any(x => $xtools.isEmpty(obj[x]))
  },
  formatNumber(x, n) {
    try {
      if ($xtools.isEmpty(x) || isNaN(parseFloat(x) || new Decimal(x).isNaN())) { return '' }
      n = $xtools.isEmpty(n) || isNaN(parseInt(n)) ? 0 : parseInt(n)
      let nString = new Decimal(x).toFixed(n).toString()
      let sp = nString.split('.')
      let fm = parseInt(sp[0]).toLocaleString('en-US')
      if (sp.length > 1) {
        fm = fm + '.' + sp[1].toString()
      }

      return fm
    } catch (err) {
      return ''
    }
  },
  formatDate(d, f) {
    if ($xt.isEmpty(d) || !moment(d).isValid()) { return '' }
    f = $xt.isEmpty(f) ? 'DD/MM/YYYY' : f
    return moment(d).format(f)
  },

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  },
  arrayMove(arr, fromIndex, toIndex) {
    var element = arr[fromIndex]
    arr.splice(fromIndex, 1)
    arr.splice(toIndex, 0, element)
  },
  toExcelHeader(num) {
    if (num <= 0) {
      return '';
    }

    var str = num.toString(26);
    var arr = str.split('').map(char => {
      var code = char.charCodeAt(0);
      if (code >= 48 && code <= 57) {
        code += 16; // convert 1-9 to A-I and 0 to @
      } else {
        code -= 23; // convert a-p to J-Z
      }
      return code;
    });

    // convert 'A@' to 'Z', 'B@' to 'AZ', etc.
    // ascii code of '@' is 64
    var index = arr.indexOf(64)
    while (index >= 0) {
      if (index == 0) {
        arr.shift();  // remove head '@'
      } else {
        arr[index] += 26;
        arr[index - 1]--;
      }
      index = arr.indexOf(64);
    }

    var chars = arr.map(code => String.fromCharCode(code));
    return chars.join('')
  }
}

export const xtools = $xtools

export const colors = ['light.purple', 'dark.purple', 'light.blue', 'dark.blue', 'light.green', 'dark.green', 'light.orange', 'dark.orange', 'light.red', 'dark.red']
